var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNadimiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 612 612",
    style: {
      enableBackground: "new 0 0 612 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414082;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.7087;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:5.6693;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 612,
    height: 612
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.6,337.52c-0.13,0-0.28,0-0.41-0.01c0.8,0.34,1.56,0.65,2.29,0.95v-1.05 C293.86,337.48,293.24,337.52,292.6,337.52z M316.67,337.27v1.12c0.69-0.29,1.4-0.59,2.15-0.89 C318.08,337.47,317.36,337.39,316.67,337.27z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218.66,
    y: 247.52,
    className: "st2",
    width: 174.68,
    height: 3.27
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 304.37,
    y: 120.2,
    className: "st2",
    width: 3.27,
    height: 128.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,138.93c-0.81,0.8-1.88,1.63-3.27,2.37c-2.34,1.25-5.6,2.21-10.06,2.16c-5.65-0.06-9-2.85-11.97-5.32 c-2.84-2.38-5.31-4.45-9.88-4.45c-4.68,0-7.59,2.15-10.97,4.63c-3.33,2.46-7.12,5.24-12.65,5.24c-6.38,0-9.84-3.23-12.64-5.81 c-2.06-1.91-3.68-3.42-6.2-3.82c-6.62-1.09-9.55,0.89-9.67,0.98l-3.35-4.33c0.48-0.36,4.88-3.5,13.93-2.03 c4.19,0.68,6.79,3.1,9.1,5.23c2.6,2.42,4.66,4.33,8.85,4.33c3.7,0,6.31-1.93,9.35-4.16c3.64-2.68,7.76-5.71,14.27-5.71 c6.6,0,10.4,3.17,13.47,5.72c2.67,2.24,4.78,4,8.44,4.03c6.39,0.05,9.06-2.41,10-3.64c0.29-0.37,0.41-0.64,0.43-0.68l2.83,1.15 V138.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,157.7c-0.81,0.8-1.88,1.64-3.27,2.37c-2.34,1.25-5.6,2.2-10.06,2.15c-5.65-0.05-9-2.85-11.97-5.32 c-2.84-2.38-5.31-4.44-9.88-4.44c-4.68,0-7.59,2.14-10.97,4.63c-3.33,2.45-7.12,5.23-12.65,5.23c-6.38,0-9.84-3.22-12.64-5.81 c-2.06-1.9-3.68-3.41-6.2-3.82c-6.61-1.09-9.55,0.9-9.67,0.99l-3.35-4.33c0.48-0.36,4.88-3.51,13.93-2.04 c4.19,0.68,6.79,3.1,9.1,5.24c2.6,2.41,4.66,4.32,8.85,4.32c3.7,0,6.31-1.92,9.35-4.15c3.64-2.68,7.76-5.71,14.27-5.71 c6.6,0,10.4,3.18,13.47,5.72c2.67,2.24,4.78,4.01,8.44,4.03c6.4,0.05,9.07-2.41,10-3.64c0.29-0.37,0.41-0.63,0.43-0.67l2.83,1.14 V157.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,172.42v4.05c-0.82,0.81-1.88,1.64-3.27,2.38c-2.34,1.25-5.6,2.2-10.06,2.14 c-5.65-0.05-9-2.84-11.97-5.32c-2.84-2.38-5.31-4.44-9.88-4.44c-4.68,0-7.59,2.14-10.97,4.63c-3.33,2.46-7.12,5.23-12.65,5.23 c-6.38,0-9.84-3.22-12.64-5.8c-2.06-1.91-3.68-3.42-6.2-3.83c-6.62-1.08-9.55,0.9-9.67,0.99l-3.35-4.33 c0.48-0.36,4.88-3.51,13.93-2.03c4.19,0.68,6.79,3.1,9.1,5.23c2.6,2.42,4.66,4.33,8.85,4.33c3.7,0,6.31-1.93,9.35-4.16 c3.64-2.68,7.76-5.71,14.27-5.71c6.6,0,10.4,3.18,13.47,5.73c2.67,2.23,4.78,4,8.44,4.03c6.39,0.03,9.08-2.44,10-3.63 c0.29-0.37,0.4-0.62,0.4-0.63L307.63,172.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,191.15v4.08c-0.82,0.8-1.88,1.63-3.27,2.36c-2.3,1.23-5.46,2.17-9.79,2.17h-0.27 c-5.65-0.05-9-2.85-11.97-5.32c-2.84-2.38-5.31-4.45-9.88-4.45c-4.68,0-7.59,2.15-10.97,4.63c-3.33,2.46-7.12,5.24-12.65,5.24 c-6.38,0-9.84-3.23-12.64-5.81c-2.06-1.91-3.68-3.42-6.2-3.82c-6.61-1.09-9.55,0.9-9.67,0.98l-3.35-4.32 c0.48-0.36,4.88-3.51,13.93-2.04c4.19,0.68,6.79,3.1,9.1,5.23c2.6,2.42,4.66,4.33,8.85,4.33c3.7,0,6.31-1.93,9.35-4.16 c3.64-2.68,7.76-5.71,14.27-5.71c6.6,0,10.4,3.17,13.47,5.72c2.67,2.24,4.78,4,8.44,4.03c6.4,0.06,9.07-2.4,10-3.64 c0.29-0.37,0.41-0.64,0.43-0.68L307.63,191.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,209.92V214c-0.81,0.8-1.88,1.63-3.27,2.37c-2.34,1.25-5.6,2.2-10.06,2.16 c-5.65-0.05-9-2.85-11.97-5.32c-2.84-2.38-5.31-4.44-9.88-4.44c-4.68,0-7.59,2.14-10.97,4.63c-3.33,2.45-7.12,5.23-12.65,5.23 c-6.38,0-9.84-3.22-12.64-5.81c-2.06-1.9-3.68-3.41-6.2-3.82c-6.62-1.08-9.55,0.9-9.67,0.99l-3.35-4.33 c0.48-0.36,4.88-3.51,13.93-2.03c4.19,0.68,6.79,3.09,9.1,5.23c2.6,2.41,4.66,4.32,8.85,4.32c3.7,0,6.31-1.92,9.35-4.15 c3.64-2.68,7.76-5.71,14.27-5.71c6.6,0,10.4,3.18,13.47,5.73c2.67,2.23,4.78,4,8.44,4.02c6.4,0.06,9.07-2.41,10-3.64 c0.29-0.37,0.41-0.63,0.43-0.67L307.63,209.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.63,228.7v4.07c-0.81,0.8-1.88,1.63-3.27,2.37c-2.34,1.25-5.6,2.2-10.06,2.16 c-5.65-0.05-9-2.84-11.97-5.32c-2.84-2.38-5.31-4.44-9.88-4.44c-4.68,0-7.59,2.15-10.97,4.63c-3.33,2.46-7.12,5.24-12.65,5.24 c-6.38,0-9.84-3.23-12.64-5.81c-2.06-1.91-3.68-3.42-6.2-3.83c-6.62-1.08-9.55,0.9-9.67,0.99l-3.35-4.33 c0.48-0.36,4.88-3.51,13.93-2.03c4.19,0.68,6.79,3.1,9.1,5.23c2.6,2.42,4.66,4.33,8.85,4.33c3.7,0,6.31-1.93,9.35-4.16 c3.64-2.68,7.76-5.71,14.27-5.71c6.6,0,10.4,3.18,13.47,5.73c2.67,2.23,4.78,4,8.44,4.03c6.4,0.06,9.07-2.4,10-3.64 c0.29-0.37,0.41-0.64,0.43-0.68L307.63,228.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.22,294.69c4.5,11.33,21.14,22.5,42.26,25.59v0.06c5.64,0.66,9.94,4.24,9.94,8.54 c0,4.3-4.3,7.88-9.94,8.54v1.05c5.22,2.15,8.72,3.57,11.05,4.5c2.36-0.96,5.91-2.4,11.15-4.57v-1.12 c-5.15-0.94-8.95-4.34-8.95-8.39c0-4.05,3.8-7.45,8.95-8.39l0.03-0.01c21.52-2.91,38.51-14.3,43.08-25.78H252.22z M288.31,312.5 c-1.22-0.12-2.43-0.27-3.65-0.43c-1.21-0.23-2.42-0.47-3.61-0.78c-1.18-0.35-2.37-0.66-3.52-1.12c-1.16-0.42-2.29-0.97-3.4-1.51 l-1.6-0.93c-0.54-0.33-1.04-0.7-1.55-1.06c-0.5-0.36-0.97-0.77-1.45-1.16c-0.44-0.44-0.91-0.85-1.32-1.33 c-0.82-0.92-1.58-1.94-2.03-3.08c0.71,1,1.57,1.84,2.5,2.61c0.44,0.39,0.94,0.73,1.4,1.1c0.51,0.32,0.98,0.68,1.49,0.98 c2.03,1.26,4.19,2.28,6.43,3.09c2.22,0.89,4.54,1.5,6.87,2.14l3.53,0.81c1.19,0.24,2.38,0.47,3.57,0.77 C290.76,312.61,289.54,312.55,288.31,312.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M406.95,106.59v152.98c0,18.04-5.43,35.75-16.05,50.24c-7.95,10.84-16.05,19.03-36.75,27.71 c-44.8,18.79-48.57,20.06-48.57,20.06s-2.94-0.85-47.73-19.63c-20.7-8.68-28.81-16.87-36.75-27.72 c-10.63-14.48-16.05-32.2-16.05-50.23V107.01L406.95,106.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.52,342.96c-5.41-2.17-17.19-6.99-42.41-17.57c-18.8-7.89-24.72-14.59-31.04-23.21 c-8.66-11.8-13.42-26.78-13.42-42.19V120.62l174.68-0.42v139.37c0,15.41-4.77,30.39-13.42,42.19c-6.31,8.61-12.23,15.31-31.04,23.2 C323.2,335.73,311.1,340.7,305.52,342.96z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 316.67,
    cy: 291.51,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 305.32,
    cy: 293.21,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 298.93,
    cy: 285.26,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 300.69,
    cy: 275.2,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 308.58,
    cy: 283.07,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 304.5,
    cy: 263.64,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 313.13,
    cy: 271.92,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 318.82,
    cy: 280.84,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 326.86,
    cy: 287.39,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 325.25,
    cy: 297.05,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 338.31,
    cy: 287.89,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 333.37,
    cy: 278.12,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 325.25,
    cy: 270.63,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 328.77,
    cy: 261.17,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 336.45,
    cy: 268.58,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 317.24,
    cy: 261.17,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 295.75,
    cy: 297.05,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 289.63,
    cy: 288.97,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 279.64,
    cy: 293.91,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 271.01,
    cy: 288.97,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 281.2,
    cy: 281.89,
    r: 4.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 290.8,
    cy: 278.9,
    r: 4.94
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.25,239.88c-0.13-1.12,0.54-1.05,1.16-1.09c2.03-0.13,4-0.57,5.46-2.06c0.61-0.62,1.08-1.63,1.13-2.5 c0.2-3.39-1.61-5.8-3.98-8.04c-2.33-2.2-4.5-4.61-6.49-7.13c-2.67-3.39-3.55-7.51-4.11-11.69c-1.02-7.51-0.18-14.71,3.63-21.38 c0.95-1.66,2.14-3.18,3.23-4.76c0.52-0.76,1.1-1.48,1.6-2.26c0.75-1.16,0.67-1.68-0.61-2.07c-3.18-0.98-6.4-1.82-9.6-2.71 c-1.33-0.37-2.3-0.76-3.59-1.24c-0.56-0.21-1.35-0.69-1.83-1.08c-0.21-0.14-0.13-0.45,0.22-0.37c0.48,0,0.97,0,1.45,0 c8.07-0.07,16.13-0.15,24.2-0.21c0.71,0,1.25-0.08,1.54-0.86c1.4-3.81,2.24-7.7,1.09-11.71c-0.46-1.59-1.29-3.1-2.17-4.52 c-0.86-1.4-1.91-2.7-3.02-3.92c-2.92-3.22-3.61-7.01-3.43-11.22c0.17-3.97,2.22-6.64,5.21-8.86c3.19-2.37,8.22-2.5,11.58-0.72 c3.33,1.76,5.07,3.91,4.9,9.13c-0.15,4.64-0.03,9.46-0.04,14.1c-0.03,10.86-0.06,21.72-0.09,32.59c-0.02,5.8,0.04,11.6-0.13,17.39 c-0.13,4.46-0.97,8.83-2.29,13.11c-0.88,2.82-2.49,5.01-4.92,6.74c-1.93,1.37-3.75,2.93-5.42,4.6c-1.8,1.8-2.5,4.17-2.8,6.67 c-0.3,2.43,0.76,4.15,4,4.75c1.12,0.21,2.3,0.15,3.44,0.28c0.24,0.03,0.45,0.37,0.67,0.57c-0.22,0.16-0.44,0.45-0.66,0.45 C353.15,239.89,346.74,239.88,340.25,239.88z M365.12,188.28c0-0.42,0-0.84,0-1.26c0-6.26,0.05-12.52-0.01-18.78 c-0.06-6.12-0.15-12.23-0.24-18.35c-0.05-3.06-0.09-6.11-0.14-9.17c-0.04-2.31,0.37-4.91-1.25-6.82 c-1.46-1.73-3.88-2.55-6.08-2.57c-1.92-0.02-3.46,0.59-5.15,1.47c-5.15,2.71-3.77,11.2-1.17,15.13c1.25,1.89,2.88,3.72,4.02,5.67 c3.82,6.53,3.38,13.02-1.26,21.37c-0.94,1.7-0.97,2.83,0.97,3.21c2.85,1.12,4.47,2.18,6.38,4.21c1.1,1.17,1.8,2.66,2.66,4.03 C364.26,187.04,365.04,188.3,365.12,188.28z M336.64,194.79c0.07,0.01,2.03-3.47,3.72-6.38c1.57-2.7,3.95-4.9,6.87-6.02 c2.99-1.15,6.36-1.25,9.2,1.36c1.32,1.2,4.23,4.77,4.45,4.96c-0.55-1.41-1.02-2.2-1.58-3.16c-4.18-7.21-12.77-7.84-17.95-1.34 c-2.04,2.56-3.28,5.52-4.2,8.64C336.95,193.48,336.8,194.14,336.64,194.79z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.09,241.26c0,0-13.02,9.39-24.76-7.04c0,0,1.28-4.27,14.09-2.77c0,0-6.83-5.76-1.71-24.33 c0,0,6.62,0,12.38,11.31c0,0,3.63-14.3,20.28-20.28c0,0,7.68,15.79-2.13,28.17c0,0,10.67-0.64,16.22,2.99 c0,0-3.84,11.32-19.64,14.62c0,0,4.91,0.96,8.11,11.84C466.92,255.77,446.22,257.91,444.09,241.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.91,241.26c0,0,13.02,9.39,24.76-7.04c0,0-1.28-4.27-14.09-2.77c0,0,6.83-5.76,1.71-24.33 c0,0-6.62,0-12.38,11.31c0,0-3.63-14.3-20.28-20.28c0,0-7.68,15.79,2.13,28.17c0,0-10.67-0.64-16.22,2.99 c0,0,3.84,11.32,19.64,14.62c0,0-4.91,0.96-8.11,11.84C145.07,255.77,165.77,257.91,167.91,241.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.27,280.84c-7.47,0-15.05-0.53-14.09-15.04c0.96-14.51,14.51-13.67,14.51-13.67 c18.78,1.08,14.94,19,16.65,33.12c1.71,14.12,11.24,28.78,11.24,28.78c9.03,14.47,23.55,26.25,51.29,36.71 c33.77,12.73,47.8,20.77,47.8,20.77H306c0,0,14.04-8.05,47.8-20.77c27.75-10.46,42.26-22.24,51.29-36.71 c0,0,9.53-14.66,11.24-28.78s-2.13-32.05,16.65-33.12c0,0,13.55-0.84,14.51,13.67c0.96,14.51-6.62,15.04-14.09,15.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "128.35,480.59 81.68,409.23 74,409.23 74,505.41 81.68,505.41 81.68,433.06 128.35,505.41  136.04,505.41 136.04,409.23 128.35,409.23  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.02,
    y: 409.23,
    className: "st2",
    width: 12.24,
    height: 95.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525.76,
    y: 409.23,
    className: "st2",
    width: 12.24,
    height: 95.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.51,407.23c0,0-12.04-1.06-21.7,8.41c-5.88,5.77-9.04,14-9.04,22.47v66.17h10.78v-34.15h39.9v34.15h10.78 v-66.17c0-8.47-3.15-16.7-9.04-22.47C209.55,406.17,197.51,407.23,197.51,407.23z M217.46,464.43h-39.9v-30.58 c0-11.16,8.29-20.55,18.86-20.91c0.36-0.01,0.72-0.02,1.09-0.02s0.73,0.01,1.09,0.02c10.57,0.37,18.86,9.75,18.86,20.91V464.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.97,408.33c-0.56-0.05-1.12-0.09-1.68-0.11c-2.7-0.13-33.03-0.16-33.03,0.01c0,0,0,96.04,0,96.04 c0.95,0.95,7.23,0.02,8.85,0.05c3.54,0.05,7.08,0.16,10.62,0.17c9.41,0.01,20.02,0.84,29-2.46c5.27-1.9,10.07-7.59,12.79-12.35 c3.14-5.49,4.74-11.8,5.36-18.06c0.97-9.73,0.64-20.09,0.22-29.85c-0.35-7.97-3.92-16.53-9.19-22.5 C310.95,412.53,302.77,409.09,293.97,408.33z M314.83,462.45c0,10.53,1,17.23-4.07,25.04c-9.12,14.06-25.84,12.49-40.36,11.85 c-0.61-10.47-0.04-21.25-0.04-31.75c0-15.79,0-31.59,0-47.38c0-0.37,0-7.28,0-7.28c3.81,0,7.62,0,11.42,0 c6.09,0,11.99-0.47,17.73,2c3.2,1.38,6.38,3.41,8.69,6.05c2.24,2.56,3.45,5.69,4.84,8.75 C315.89,435.98,314.83,451.92,314.83,462.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M485.84,413.45c-0.04-0.03-0.08-0.07-0.13-0.1c-4.64-3.73-10.54-5.95-16.95-5.95 c-6.79,0-12.99,2.5-17.75,6.63c-1.74,1.51-3.28,3.24-4.58,5.14c-1.27-1.84-2.76-3.52-4.43-4.99c-4.77-4.22-11.05-6.77-17.92-6.77 c-6.45,0-12.38,2.26-17.04,6.03c-0.3,0.25-0.6,0.5-0.9,0.76c-5.27,4.65-8.11,11.48-8.11,18.51v71.58h9.01v-71.94 c0-4.59,1.38-9.12,4.19-12.74c3.23-4.16,7.8-6.75,12.86-6.75c9.26,0,16.88,8.72,17.65,19.8c0.04-0.81,0.26,71.63,0.26,71.63h9.01 c0,0,0.08-72.07,0.11-71.71c0.79-11.05,8.4-19.73,17.64-19.73c4.65,0,8.89,2.2,12.05,5.78c3.26,3.7,4.9,8.55,4.9,13.48v72.17h9.01 v-71.69C494.73,425.21,491.57,418.1,485.84,413.45z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNadimiLogo);
export default __webpack_public_path__ + "static/media/NADIMI_logo.6b2c5de032f6c57b3acff647ef2e73ed.svg";
export { ForwardRef as ReactComponent };